import { ThemeProvider } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import ReactDOM from "react-dom/client";
import { useTranslation } from "react-i18next";

const MyConfirmationDialog = ({ title, message, theme, resolve }) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(true);

  const onConfirm = () => {
    setDialogOpen(false);
    removeDialog();
    resolve(true);
  };

  const onDismiss = () => {
    setDialogOpen(false);
    removeDialog();
    resolve(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={dialogOpen} onClose={onDismiss}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions style={{ paddingBottom: "1rem", paddingRight: "1.5rem" }}>
          <Button onClick={onDismiss}>{t("cancel")}</Button>
          <Button color="primary" variant="contained" onClick={onConfirm}>
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export const getConfirmation = ({ title, message, theme }) => {
  return new Promise((resolve, reject) => {
    addDialog(title, message, theme, resolve);
  });
};

function addDialog(title, message, theme, resolve) {
  const body = document.getElementsByTagName("body")[0];
  const div = document.createElement("div");
  div.setAttribute("id", "getValue-container");
  body.appendChild(div);
  let root = ReactDOM.createRoot(div);
  root.render(<MyConfirmationDialog resolve={resolve} title={title} message={message} theme={theme} />);
}

function removeDialog() {
  const div = document.getElementById("getValue-container");
  const body = document.getElementsByTagName("body")[0];
  body.removeChild(div);
}
